import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Button from '@client/components/inputs/button/Button';
import Flex from '@client/components/flex/Flex';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './announcementsHeader.scss';

const AnnouncementsHeader = ({ onContactClick }) => {
  const { t } = useTranslation(['advertiser']);
  return (
    <section className={styles.announcementsHeader}>
      <Flex column className={styles.backgroundOnlyDesktop}>
        <Flex className={styles.firstSection}>
          <Flex className={styles.firstSectionCopyContent}>
            <h1 className={styleHelper.landingH2}>
              {t('advertiser:header.title')}
            </h1>
            <p
              className={classNames(
                styleHelper.landingP1,
                styleHelper.mgt8,
                styles.headerParagraph
              )}
            >
              {t('advertiser:header.description')}
            </p>
            <Button
              className={classNames(
                styleHelper.btnContained,
                styleHelper.mgt24,
                styles.button
              )}
              label={t('advertiser:header.button')}
              onClick={onContactClick}
            />
          </Flex>
        </Flex>
        <Flex className={styles.secondSection}>
          <Flex className={styles.secondSectionCopyContent}>
            <h4 className={styleHelper.landingDefaultText}>
              {t('advertiser:firstSection.label')}
            </h4>
            <h2 className={classNames(styleHelper.landingH3, styleHelper.mgt8)}>
              {t('advertiser:firstSection.title')}
            </h2>
            <p className={classNames(styleHelper.landingP1, styleHelper.mgt16)}>
              {t('advertiser:firstSection.description')}
            </p>
            <p className={classNames(styleHelper.landingP2, styleHelper.mgt16)}>
              {t('advertiser:firstSection.body')}
            </p>
          </Flex>
        </Flex>
      </Flex>
    </section>
  );
};

AnnouncementsHeader.propTypes = {
  onContactClick: PropTypes.func,
};
export default AnnouncementsHeader;
